'use strict';

var DISMISSED_COOKIE_NAME = 'bc_geo_locale_popup_dismissed';
var POPUP_DELAY_MILLISECONDS = 5000;
var POLL_INTERVAL_MILLISECONDS = 500;
var MAX_POLL_WAIT_MILLISECONDS = 60000;

var GEO_DRAWER_SELECTOR = '#geo-location-drawer-modal';
var GEO_CONTENT_CONTAINER_SELECTOR = '#geo-location-content-container';
var GEO_BACKDROP_CSS_CLASS = 'geo-location-backdrop';
var isGeoDrawerInteractive = false;

/**
 * Reads a cookie value by name.
 * @param {string} cookieName - the name of the cookie to read
 * @returns {string} the cookie value, or an empty string if not found
 */
function getCookieValue(cookieName) {
    var allCookies = '; ' + (document.cookie || '');
    var match = allCookies.match('; ' + cookieName + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : '';
}

/**
 * Writes a 30-day cookie to record that the geo-location popup was dismissed.
 * @param {string} [localeCode] - the accepted locale code to persist (optional)
 */
function setDismissedCookie(localeCode) {
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + 30 * 24 * 60 * 60 * 1000);
    var cookieValue = localeCode ? encodeURIComponent(localeCode) : 'dismiss';
    document.cookie = DISMISSED_COOKIE_NAME + '=' + cookieValue + '; expires=' + expiryDate.toUTCString() + '; path=/; SameSite=Lax';
}

/**
 * Fills the detected-country and current-country text placeholders inside the drawer.
 */
function updateCountryNamePlaceholders() {
    var $description = $(GEO_DRAWER_SELECTOR + ' .description');
    var detectedCountryName = $description.attr('data-detected-country');
    var currentCountryName = $description.attr('data-current-country');

    if (detectedCountryName) {
        $('.detected-country').text(detectedCountryName);
    }
    if (currentCountryName) {
        $('.current-country').text(currentCountryName);
    }
}

/**
 * Rebuilds the language dropdown to show only languages available for the selected country.
 * Restores the previously selected language if still available, otherwise selects the first match.
 * @param {string} selectedCountryCode - the ISO country code chosen by the shopper
 */
function rebuildLanguageDropdown(selectedCountryCode) {
    var $geoDrawer = $(GEO_DRAWER_SELECTOR);
    var $languageMenu = $geoDrawer.find('[data-dropdown-menu="language"]');

    var $allLanguageOptions = $languageMenu.find('.country-selector-dropdown-option');
    $allLanguageOptions.addClass('d-none');
    $allLanguageOptions.removeAttr('data-selected');
    $allLanguageOptions.find('.checkmark').text('');

    var previousLanguageCode = $languageMenu.find('.country-selector-dropdown-option[data-selected="true"]').attr('data-value');

    // Show options for the selected country, skip duplicates, track the best pre-selection
    var shownLanguageCodes = {};
    var $optionToPreselect = null;

    $allLanguageOptions.each(function () {
        var $option = $(this);
        var languageCode = $option.data('value');

        if ($option.data('country') !== selectedCountryCode || shownLanguageCodes[languageCode]) {
            return;
        }

        shownLanguageCodes[languageCode] = true;
        $option.removeClass('d-none');

        if ($optionToPreselect === null || languageCode === previousLanguageCode) {
            $optionToPreselect = $option;
        }
    });

    if ($optionToPreselect && $optionToPreselect.length) {
        $optionToPreselect.attr('data-selected', 'true');
        $optionToPreselect.find('.checkmark').text('✓');
        $geoDrawer.find('[data-dropdown="language"] .country-selector-dropdown-selected').text($optionToPreselect.find('.option-text').text());
        $geoDrawer.find('#geo-language-select').val($optionToPreselect.data('value'));
    }

    if (Object.keys(shownLanguageCodes).length <= 1) {
        $geoDrawer.find('.language').addClass('d-none');
    } else {
        $geoDrawer.find('.language').removeClass('d-none');
    }
}

/**
 * Returns the currently selected (or first visible) option element for a dropdown.
 * @param {jQuery} $geoForm - the geo-location form element
 * @param {string} dropdownName - the dropdown identifier: "country" or "language"
 * @returns {jQuery} the selected option element
 */
function getSelectedDropdownOption($geoForm, dropdownName) {
    var optionSelector = '[data-dropdown-menu="' + dropdownName + '"] .country-selector-dropdown-option';
    var $selectedOption = $geoForm.find(optionSelector + '[data-selected="true"]').not('.d-none');

    if (!$selectedOption.length) {
        $selectedOption = $geoForm.find(optionSelector).not('.d-none').first();
    }

    return $selectedOption;
}

/**
 * Returns true if a modal or consent overlay is currently blocking the screen.
 * @returns {boolean} true when another overlay is open, false otherwise
 */
function isAnotherOverlayCurrentlyOpen() {
    return $('#consent-tracking').is(':visible')
        || $('.cookie-warning-messaging').is(':visible')
        || $('body').hasClass('modal-open')
        || $('body').hasClass('drawer-open')
        || $('.modal.show').length > 0;
}

/**
 * Closes the geo-location drawer and optionally sets the dismissed cookie.
 * @param {boolean} shouldSetDismissedCookie - pass true to mark the popup as dismissed
 */
function closeGeoDrawer(shouldSetDismissedCookie) {
    var $geoDrawer = $(GEO_DRAWER_SELECTOR);

    $geoDrawer.removeClass('drawer-open');
    $geoDrawer.attr('aria-hidden', 'true');
    $('body').removeClass('drawer-open');

    if (!$('body').hasClass('modal-open')) {
        $('.modal-backdrop.' + GEO_BACKDROP_CSS_CLASS).remove();
    }

    if (shouldSetDismissedCookie) {
        setDismissedCookie();
    }
}

/**
 * Opens the geo-location drawer, lazily cloning the pre-rendered server HTML on first use.
 */
function openGeoDrawer() {
    var $geoDrawer = $(GEO_DRAWER_SELECTOR);

    if (!$geoDrawer.children('.country-selector-content').length) {
        var containerHtml = $(GEO_CONTENT_CONTAINER_SELECTOR).html();

        if (!containerHtml || !containerHtml.trim()) {
            return;
        }

        $geoDrawer.html(containerHtml);
        $geoDrawer.find('.country-selector-dropdown-option[data-selected="true"] .checkmark').text('✓');

        var initialCountryCode = $geoDrawer.find('#geo-country-select').val();
        if (initialCountryCode) {
            rebuildLanguageDropdown(initialCountryCode);
        }
    }

    updateCountryNamePlaceholders();

    if (!$('.modal-backdrop').length) {
        $('body').append('<div class="modal-backdrop fade show ' + GEO_BACKDROP_CSS_CLASS + '"></div>');
    }

    $geoDrawer.addClass('drawer-open');
    $geoDrawer.attr('aria-hidden', 'false');
    $('body').addClass('drawer-open');

    isGeoDrawerInteractive = false;
    setTimeout(function () {
        isGeoDrawerInteractive = true;
    }, 500);
}

/**
 * Calls the Page-SetLocale endpoint and redirects the shopper to the returned URL.
 * @param {string} endpointUrl - the Page-SetLocale controller endpoint URL
 * @param {string} localeCode - the locale code to switch to (e.g. "en_AT")
 * @param {string} currencyCode - the ISO currency code matching the locale
 * @param {jQuery|null} $spinnerElement - optional element on which to show a loading spinner
 */
function redirectToLocale(endpointUrl, localeCode, currencyCode, $spinnerElement) {
    if ($spinnerElement) {
        $spinnerElement.spinner().start();
    }

    $.ajax({
        url: endpointUrl,
        type: 'get',
        dataType: 'json',
        data: {
            code: localeCode,
            CurrencyCode: currencyCode,
            queryString: $('.page').data('querystring'),
            action: $('.page').data('action')
        },
        success: function (response) {
            if ($spinnerElement) {
                $spinnerElement.spinner().stop();
            }
            setDismissedCookie(localeCode);
            if (response && response.redirectUrl) {
                window.location.href = response.redirectUrl;
            }
        },
        error: function () {
            if ($spinnerElement) {
                $spinnerElement.spinner().stop();
            }
        }
    });
}

/**
 * Reads the selected country and language from the form and initiates the locale redirect.
 * @param {HTMLFormElement} formElement - the submitted geo-location form element
 * @returns {boolean} always false to prevent native form submission
 */
function submitGeoLocationForm(formElement) {
    var $geoForm = $(formElement);
    var $selectedCountryOption = getSelectedDropdownOption($geoForm, 'country');
    var $selectedLanguageOption = getSelectedDropdownOption($geoForm, 'language');

    var selectedCountryCode = $selectedCountryOption.attr('data-value');
    var selectedLanguageCode = $selectedLanguageOption.attr('data-value');

    redirectToLocale(
        $geoForm.attr('action'),
        selectedLanguageCode + '_' + selectedCountryCode,
        $selectedCountryOption.data('currency-code'),
        $(GEO_DRAWER_SELECTOR)
    );

    return false;
}

/**
 * Polls at a fixed interval until no blocking overlay is present, then calls the callback.
 * Stops after MAX_POLL_WAIT_MILLISECONDS regardless of outcome.
 * @param {Function} callback - function to invoke when the screen is clear
 */
function waitUntilScreenIsClear(callback) {
    if (!isAnotherOverlayCurrentlyOpen()) {
        callback();
        return;
    }

    var totalWaitedMilliseconds = 0;

    var pollInterval = setInterval(function () {
        totalWaitedMilliseconds += POLL_INTERVAL_MILLISECONDS;

        if (!isAnotherOverlayCurrentlyOpen() || totalWaitedMilliseconds >= MAX_POLL_WAIT_MILLISECONDS) {
            clearInterval(pollInterval);
            if (!isAnotherOverlayCurrentlyOpen()) {
                callback();
            }
        }
    }, POLL_INTERVAL_MILLISECONDS);
}

/**
 * Registers all event handlers for the geo-location drawer.
 * Uses delegated events so dynamically cloned drawer content remains interactive.
 */
function registerEventHandlers() {
    var closeButtonSelector = GEO_DRAWER_SELECTOR + ' .geo-location-close, ' + GEO_DRAWER_SELECTOR + ' .geo-location-stay';

    $(document).on('click', closeButtonSelector, function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeGeoDrawer(true);
    });

    $(document).on('click', GEO_DRAWER_SELECTOR + ' .geo-location-international', setDismissedCookie);

    // Country change: sync the hidden select and rebuild the language list
    $(document).on('click', GEO_DRAWER_SELECTOR + ' [data-dropdown-menu="country"] .country-selector-dropdown-option', function () {
        var clickedCountryCode = String($(this).data('value'));
        $(GEO_DRAWER_SELECTOR).find('#geo-country-select').val(clickedCountryCode);
        rebuildLanguageDropdown(clickedCountryCode);
    });

    // Language change: sync the hidden select
    $(document).on('click', GEO_DRAWER_SELECTOR + ' [data-dropdown-menu="language"] .country-selector-dropdown-option', function () {
        $(GEO_DRAWER_SELECTOR).find('#geo-language-select').val(String($(this).data('value')));
    });

    $(document).on('submit', GEO_DRAWER_SELECTOR + ' form.geo-location-form', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return submitGeoLocationForm(this);
    });

    // Submit button click/touch for mobile compatibility
    $(document).on('click touchend', GEO_DRAWER_SELECTOR + ' form.geo-location-form button[type="submit"]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('form.geo-location-form').trigger('submit');
    });

    // Backdrop click closes without dismissing
    $(document).on('click touchend', '.modal-backdrop.' + GEO_BACKDROP_CSS_CLASS, function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isGeoDrawerInteractive) {
            return;
        }
        closeGeoDrawer(true);
    });

    // Escape key closes without dismissing
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $(GEO_DRAWER_SELECTOR).hasClass('drawer-open')) {
            closeGeoDrawer(false);
        }
    });
}

module.exports = function () {
    registerEventHandlers();

    var $geoContent = $(GEO_CONTENT_CONTAINER_SELECTOR + ' .geo-location-content');

    if (!$geoContent.length) {
        return;
    }

    if (String($geoContent.data('should-show')) !== 'true') {
        return;
    }

    var isDetectedLocaleSupported = String($geoContent.data('is-supported')) === 'true';
    var dismissedCookieValue = getCookieValue(DISMISSED_COOKIE_NAME);

    if (dismissedCookieValue) {
        if (dismissedCookieValue === 'dismiss' || !isDetectedLocaleSupported) {
            return;
        }

        var geoFormAction = $(GEO_CONTENT_CONTAINER_SELECTOR + ' form.geo-location-form').attr('action');
        var suggestedCurrencyCode = String($geoContent.data('suggested-currency') || '');

        if (geoFormAction) {
            redirectToLocale(geoFormAction, dismissedCookieValue, suggestedCurrencyCode, null);
        }

        return;
    }

    // First visit with a geo mismatch — wait for the screen to clear, then show after the delay
    waitUntilScreenIsClear(function () {
        setTimeout(function () {
            if (!isAnotherOverlayCurrentlyOpen() && !getCookieValue(DISMISSED_COOKIE_NAME)) {
                openGeoDrawer();
            }
        }, POPUP_DELAY_MILLISECONDS);
    });
};
